import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

class LeadGoogleAdsInfo extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="adwords-info-box">
                <h3 className="adwords-info-header">{t('lead_detail.source')}</h3>
                <div className="adwords-info-input">
                    <p className="adwords-info-label">{t('lead_detail.campaign')}</p>
                    <p>{this.props.leadData.campaign}</p>
                </div>
                <div className="adwords-info-input">
                    <p className="adwords-info-label">{t('lead_detail.adgroup')}</p>
                    <p>{this.props.leadData.adgroup}</p>
                </div>
                <div className="adwords-info-input">
                    <p className="adwords-info-label">{t('lead_detail.keyword')}</p>
                    <p>{this.props.leadData.keyword}</p>
                </div>
            </div>
        )
    }
}

export default withTranslation()(LeadGoogleAdsInfo);